import {
  JourneyProvider
} from '@vodacom/web-common';

export const setStorageWithExpiry = (
  journey,
  key,
  data,
  expireMidnight = false,
  ttl = 24 * 3600 * 1000 // default ttl: 1 day
) => {

  if (data === null || data === undefined) {
    JourneyProvider.set(journey, { [key]: data }, true);
    return;
  }

  const now = new Date();
  let expiry = now.getTime() + ttl;

  if (expireMidnight) {
    expiry = new Date().setHours(23, 59, 59, 0);
  }

	const item = {
		data: data,
		expiry: expiry
  };

  JourneyProvider.set(journey, { [key]: JSON.stringify(item) }, true);
};

export const getStorageWithExpiry = (
  journey,
  key,
  defaultValue
) => {

  const itemString = JourneyProvider.get(journey, key);

	if (!itemString) {
		return defaultValue;
  }

  let item;

  try {
    item = JSON.parse(itemString);
  } catch (e) {
    item = null;
  }

  if (!item || !item.data) {
    return defaultValue;
  }

  const now = new Date();

	if (now.getTime() > item.expiry) {
    JourneyProvider.set(journey, { [key]: null }, true);
		return defaultValue;
  }

	return item.data;
};
